<script setup lang="ts">
import { computed } from 'vue';
import { tagIconToClass, type TagIconTheme } from '../lib/icons';
import {
    TagIcon,
    Color,
} from '@precon-tools-suite-by-shared/precon-graphql-types';
import {
    textColorClass,
    type ColorTint,
} from '@precon-tools-suite-by-shared/shared-colors-ui';

const props = withDefaults(
    defineProps<{
        icon?: TagIcon | null | undefined;
        color?: Color | null | undefined;
        tint?: ColorTint;
        iconMap?: TagIconTheme;
        size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl';
        loading?: boolean;
        loadingIconClass?: string;
        emptyIconClass?: string;
    }>(),
    {
        icon: undefined,
        color: undefined,
        size: 'base',
        tint: '300',
        iconMap: 'pi-normal',
        loadingIconClass: 'pi pi-spinner pi-spin',
        emptyIconClass: 'pi pi-question',
    }
);

const iconClass = computed(() => {
    if (props.loading) return props.loadingIconClass;
    if (!props.icon) return props.emptyIconClass;
    return tagIconToClass(props.icon, props.iconMap);
});

const colorClass = computed(() => {
    if (!props.color) return undefined;
    return textColorClass(props.color, props.tint);
});
</script>

<template>
    <i
        :data-tag-icon="props.icon ?? undefined"
        :data-color="props.color ?? undefined"
        :class="['tag-icon', `text-${size}`, colorClass, iconClass]"
    ></i>
</template>
